import Button from 'carbon-react/lib/components/button';
import classNames from 'classnames';
import React from 'react';

import { SignupEstimate } from '@futrli-sdk/billing';
import { formatMinorUnitsAmount, FormattedMessage, WrappedComponentProps, injectIntl } from '@futrli/localisation';

import { BillingTerm } from '../../../core/types';
import styles from './activate-product-dialog.scss';

interface OwnProps {
  signupEstimates: SignupEstimate;
  onSelectPlan: (term: BillingTerm) => void;
}
type Props = OwnProps & WrappedComponentProps;

/**
 * Renders the different billing plans for a product.
 * @param {Props} props
 * @returns {JSX.Element}
 */
export const ProductPlanSelectionComponent = ({ signupEstimates, intl, onSelectPlan }: Props): JSX.Element => {
  const handleGoPro = (term: BillingTerm) => (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    onSelectPlan(term);
  };

  return (
    <div className={styles.plansContainer}>
      <div className={classNames(styles.planContainer, styles.active)}>
        <div>
          <strong>
            <FormattedMessage id="common.monthly" defaultMessage="Monthly" />
          </strong>
        </div>
        <div>
          <span>
            <strong>
              {formatMinorUnitsAmount(signupEstimates.estimated_cost, signupEstimates.currency_code, intl)}
            </strong>
            <span className="uiTypeOtherAction">
              <FormattedMessage id="billing.per_month" defaultMessage=" /month" />
            </span>
          </span>
        </div>
        <div>
          <Button onClick={handleGoPro(signupEstimates.term)} buttonType='primary'>
            <FormattedMessage id="billing.subscribe" defaultMessage="Subscribe" />
          </Button>
        </div>
      </div>
    </div>
  );
};
export const ProductPlanSelection = injectIntl(ProductPlanSelectionComponent);
